module.exports = __webpack_public_path__ + "img/18_106.2f860eb0.png";